import { INTEGRATION_PROVIDERS } from '@vy/types';
import { raise, validateNotNullOrUndefined } from '@vy/utils';
import { useMemo } from 'react';
import { useIntegrationSettings } from '../../../../../../../hooks/requests/use-integration-settings';
import type { PaddleConfigurationFormValues } from '../PaddleConfigurationFormSchema';
import type { PaddleIntegrationSettings } from '@vy/integrations-types';

type FetchPaddleSettingsResult = {
  integrationId: string;
  configuration: PaddleConfigurationFormValues;
};

export function useFetchPaddleSettings(): FetchPaddleSettingsResult {
  const integrationSettingsResponse = useIntegrationSettings(INTEGRATION_PROVIDERS.paddle);
  const paddleIntegrationSettings = integrationSettingsResponse.data;

  validateNotNullOrUndefined(paddleIntegrationSettings, 'paddleIntegrationSettings');

  const { integrationId, integrationSettings } = paddleIntegrationSettings;

  return useMemo(
    () => ({
      integrationId,
      configuration: mapIntegrationSettingsToFormValues(integrationSettings as PaddleIntegrationSettings),
    }),
    [integrationId, integrationSettings],
  );
}

function mapIntegrationSettingsToFormValues(
  integrationSettings: PaddleIntegrationSettings,
): PaddleConfigurationFormValues {
  if (integrationSettings.integrationProvider !== INTEGRATION_PROVIDERS.paddle) {
    raise(`Invalid integration provider ${integrationSettings.integrationProvider}`);
  }

  return {
    apiToken: integrationSettings.integrationConfiguration.authConfig.apiKey,
    environment: integrationSettings.integrationConfiguration.authConfig.environment,
    autoExportInvoices: integrationSettings.integrationConfiguration.generalConfig?.autoExportInvoices,
  };
}
